import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
    try {
        const env = process.env.NODE_ENV || "production";
        Sentry.init({
            dsn,
            environment: env,
            tracesSampleRate: env === "production" ? 0.2 : 1.0,
            replaysSessionSampleRate: env === "production" ? 0.0 : 1.0,
            replaysOnErrorSampleRate: 1.0,
            sendDefaultPii: false,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: true,
                    blockAllMedia: true,
                }),
            ],
            tracePropagationTargets: ["localhost", /^\//, /^https:\/\/.*\.energize\.fit/],
        });
    } catch (e) {
        // Never let monitoring break the app
        // eslint-disable-next-line no-console
        console.warn("Sentry init failed:", e);
    }
}

export default Sentry;
